
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Rating Condition Name</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Rating Condition Name</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="RatingConditionName">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'RatingConditionNameList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="form-row">
                  <div class="form-group col-6 required">
                    <label class="control-label">Name</label>
                    <input type="text" id="name" name="name" v-bind:class="{'has-error' : errors.has('name')}" v-validate="'required'" v-model="value.name" class="form-control name" placeholder="Name">
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>
                  <div class="form-group col-6 ">
                    <label class="control-label">Description</label>
                    <input type="text" id="description" name="description" v-bind:class="{'has-error' : errors.has('description')}" v-model="value.description" class="form-control description" placeholder="Description">
                    <div class="help text-danger" v-show="errors.has('description')">
                      {{ errors.first("description") }}
                    </div>
                  </div>
                  <div class="seperator col-12">
                    <h5>Validation Schema</h5>
                    <hr>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Datatype</label>
                    <select id="validation_schema.type" name="validation_schema.type" v-bind:class="{'has-error' : errors.has('validation_schema.type')}" v-validate="'required'" v-model="value.validation_schema.type" class="form-control">
                      <option value="string">String</option>
                      <option value="number">Number</option>
                      <option value="date">Date</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('validation_schema.type')">
                      {{ errors.first("validation_schema.type") }}
                    </div>
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Minimum value/length</label>
                    <input type="text" id="validation_schema.min" name="validation_schema.min" v-model="value.validation_schema.min" class="form-control validation_schema.min" placeholder="Min">
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Maximum value/length</label>
                    <input type="text" id="validation_schema.max" name="validation_schema.max" v-model="value.validation_schema.max" class="form-control validation_schema.max" placeholder="Max">
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Regular expression</label>
                    <input type="text" id="validation_schema.regex" name="validation_schema.regex" v-model="value.validation_schema.regex" class="form-control validation_schema.regex" placeholder="Regular expression">
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Date format</label>
                    <select id="validation_schema.format" name="validation_schema.format" v-bind:class="{'has-error' : errors.has('validation_schema.format')}" v-model="value.validation_schema.format" class="form-control">
                      <option value="YYYY-MM-DD HH:mm:ss">MySQL Date Format</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('validation_schema.format')">
                      {{ errors.first("validation_schema.format") }}
                    </div>
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Default value</label>
                    <input type="text" id="validation_schema.default" name="validation_schema.default" v-model="value.validation_schema.default" class="form-control validation_schema.default" placeholder="Default value">
                  </div>
                  <div class="seperator col-12">
                    <hr>
                  </div>
                  <div class="form-group col-6 ">
                    <label class="control-label">App-ID</label>
                    <select id="app_id" name="app_id" v-bind:class="{'has-error' : errors.has('app_id')}" v-validate="'required'" v-model="value.app_id" class="form-control">
                      <option v-for="application in allApplications" :value="application.app_id" :key="application.app_id">{{ application.name }}</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('app_id')">
                      {{ errors.first("app_id") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { CBSProductRatingApi, CBSCommonApi } from '@/services/api';

export default {
  name: 'RatingConditionNameForm',
  components: {
  },
  computed: {
    ...mapGetters(["profile"])
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {
      validation_schema: {}
    },
    allApplications: [],
    pre: {}
  }),
  methods: {
    handleSubmission () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.is_loading = true
          if (this.is_edit) {
            this.value.updated_by = this.profile.id
            CBSProductRatingApi.updateRatingConditionName(this.params.id, this.value)
              .then((response) => {
                if (response.code == 200) {
                  this.$router.push({ name: "RatingConditionNameList" })
                  this.$toaster.success(response.message)
                } else {
                  this.$toaster.error(response.message)
                }
              })
              .catch((error) => {
                this.$toaster.error(error.data);
              })
              .finally(() => {
                this.is_loading = false
              })
          } else {
            this.value.organization_ref_id = this.profile.organization_ref_id
            this.value.user_ref_id = this.profile.user_ref_id
            this.value.role_ref_id = this.profile.role_ref_id
            this.value.created_by = this.profile.id
            CBSProductRatingApi.storeRatingConditionName(this.value)
              .then((response) => {
                if (response.code == 200) {
                  this.$router.push({ name: 'RatingConditionNameList' })
                  this.$toaster.success(response.message)
                } else {
                  this.$toaster.error(response.message)
                }
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.data)
              })
              .finally(() => {
                this.is_loading = false
              })
          }
        }
      });
    },
    getDetail: function (id) {
      CBSProductRatingApi.showRatingConditionName(id)
        .then((item) => {
          this.value = item
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    getApplications: function () {
      CBSCommonApi.getAllApplications().then((response) => {
        this.allApplications = response
      });
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        this.getDetail(this.params.id)
      }
      this.getApplications()
      this.is_loading = false

    }
  },
  mounted () {
    this.initialize()
  }
}
</script>
